import React from "react";
import { Container, Row, Col} from "react-bootstrap";
import suv40 from "../assets/new-images/crysta.png";
import sedan from "../assets/new-images/dezire.png";
import bus from "../assets/new-images/winger.png";
import busnew from "../assets/new-images/sml.png";
import tata from "../assets/new-images/tata.png";

const Fleet = () => {
  return (
    <div>
      <div className="inner-banner">
        <Container>
          <Row>
            <Col xs={12} md={12} className="pr-0">
              <div className="contact-banner text-center">
                <h4>Our Fleets</h4>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="section">
        <Container>
          <Row>
            <Col xs={12} md={12}>
              <div className="main-title text-center">
                <h4>Company Own Fleet </h4>
                
              </div>
            </Col>
          </Row>
          <Row className="gx-1 gy-3  pt-40">
            <Col xs={12} md={3}>
              <div className="service-content">
                <div className="fleet-card">
                    <img src={suv40} className="img-fluid" alt="logo" />
                    <h4>SUV</h4>
                </div>
              </div>
            </Col>
            <Col xs={12} md={3}>
              <div className="service-content">
                <div className="fleet-card">
                    <img src={sedan} className="img-fluid" alt="logo" />
                    <h4>Sedans</h4>
                </div>
              </div>
            </Col>
            <Col xs={12} md={3}>
              <div className="service-content">
                <div className="fleet-card">
                    <img src={bus} className="img-fluid" alt="logo" />
                    <h4>12 Seater Winger</h4>
                </div>
              </div>
            </Col>
            <Col xs={12} md={3}>
              <div className="service-content">
                <div className="fleet-card">
                    <img src={busnew} className="img-fluid" alt="logo" />
                    <h4>22 Seater SML</h4>
                </div>
              </div>
            </Col>
            <Col xs={12} md={3}>
              <div className="service-content">
                <div className="fleet-card">
                    <img src={tata} className="img-fluid" alt="logo" />
                    <h4>36 Tata ultra</h4>
                </div>
              </div>
            </Col>
           
          </Row>
         
        </Container>
      </div>
    </div>
  );
};

export default Fleet;
